"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiErrorOutline16 = {
    paths: [
        {
            path: 'M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 Z M8,10 C8.55228475,10 9,10.4477153 9,11 C9,11.5522847 8.55228475,12 8,12 C7.44771525,12 7,11.5522847 7,11 C7,10.4477153 7.44771525,10 8,10 Z M9,4 L9,9 L7,9 L7,4 L9,4 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Error',
    width: 16,
    height: 16,
};
var muiErrorOutline24 = {
    paths: [
        {
            path: 'M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M11,2 C6.02943725,2 2,6.02943725 2,11 C2,15.9705627 6.02943725,20 11,20 C15.9705627,20 20,15.9705627 20,11 C20,6.02943725 15.9705627,2 11,2 Z M12.5,5 L12.5,12.5 L9.5,12.5 L9.5,5 L12.5,5 Z M11,17 C11.8284271,17 12.5,16.3284271 12.5,15.5 C12.5,14.6715729 11.8284271,14 11,14 C10.1715729,14 9.5,14.6715729 9.5,15.5 C9.5,16.3284271 10.1715729,17 11,17 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Error',
    width: 22,
    height: 22,
};
var muiErrorOutline = {
    base: muiErrorOutline16,
    smIcon: muiErrorOutline16,
    lgIcon: muiErrorOutline24,
};
exports.muiErrorOutline = muiErrorOutline;
//# sourceMappingURL=errorOutline.js.map